let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9iuvn")).then(() => parcelRequire('9Wrrk'));